import { render } from "./index.vue?vue&type=template&id=f9a1beca&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=f9a1beca&lang=scss&scoped=true"

import exportComponent from "D:\\Users\\user\\Desktop\\production\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9a1beca"]])

export default __exports__